<template>
  <sidebar-navigation>
    <transition
      enter-active-class="transform transition ease-in-out duration-700 sm:duration-700"
      enter-class="translate-x-full"
      enter-to-class="translate-x-0"
      leave-active-class="transform transition ease-in-out duration-700 sm:duration-700"
      leave-class="translate-x-0"
      leave-to-class="translate-x-full"
    >
      <notification
        v-show="successNotification"
        message="Berhasil! Update label"
        @close="successNotification = false"
      ></notification>
    </transition>
    <div class="p-4 bg-white rounded-lg shadow">
      <h2 class="text-lg font-semibold mb-4">Create/Edit Label Printer</h2>
      <div>
        <div class="mb-4">
          <label for="title" class="block text-sm font-medium text-gray-700"
            >Nama Usaha / Label</label
          >
          <input
            type="text"
            id="title"
            v-model="form.title"
            class="mt-1 p-2 w-full border rounded-md"
          />
        </div>

        <div class="mb-4">
          <label for="image" class="block text-sm font-medium text-gray-700"
            >Logo</label
          >
          <input
            type="file"
            id="image"
            @change="handleImage"
            class="mt-1 p-2 w-full border rounded-md"
          />
          <img
            v-if="imageUrl"
            :src="imageUrl"
            class="mt-2 w-24 h-24 object-cover rounded"
          />
        </div>

        <div class="mb-4">
          <label
            for="description"
            class="block text-sm font-medium text-gray-700"
            >Website</label
          >
          <input
            id="description"
            v-model="form.website"
            type="text"
            class="mt-1 p-2 w-full border rounded-md"
          />
        </div>

        <div class="mb-4">
          <label
            for="description"
            class="block text-sm font-medium text-gray-700"
            >Deskripsi</label
          >
          <textarea
            id="description"
            v-model="form.description"
            rows="4"
            class="mt-1 p-2 w-full border rounded-md"
          ></textarea>
        </div>

        <div class="flex gap-3">
          <button
            @click="showModal = true"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Preview
          </button>
          <button
            @click="submitForm"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="showModal"
      class="fixed inset-0 z-50 overflow-y-auto blur-bg"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      @click="showModal = false"
    >
      <div class="flex items-center justify-center pt-4 px-4 pb-20 text-center">
        <div
          class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full"
        >
          <div class="px-2 py-5">
            <p class="text-red-600 text-xs pb-3">
              * ) Data ini hanya sebagai contoh
            </p>
            <resi-example />
          </div>
        </div>
      </div>
    </div>
  </sidebar-navigation>
</template>

<script>
import { api_url } from "@/config/api";
import SidebarNavigation from "@/components/SidebarNavigation";
import ResiExample from "../components/resiExample.vue";
import axios from "axios";
import Notification from "../components/datatables/notification.vue";

export default {
  components: { SidebarNavigation, ResiExample, Notification },
  data() {
    return {
      headers: JSON.parse(
        window.sessionStorage.getItem("token-auth-jaskipin-agen")
      ),
      form: {
        title: this.labelData?.company_name,
        website: this.labelData?.company_description,
        description: this.labelData?.company_address,
        image: null,
      },
      imageUrl: this.labelData?.company_logo,
      showModal: false,
      successNotification: false,
    };
  },

  watch: {
    labelData: {
      handler(newVal) {
        if (newVal) {
          this.form.title = newVal.company_name || "";
          this.form.website = newVal.company_description || "";
          this.form.description = newVal.company_address || "";
          this.imageUrl = newVal.company_logo || null;
        }
      },
      immediate: true, // This makes sure the watcher runs when the component is created
    },
  },
  computed: {
    userData() {
      let profile = JSON.parse(
        window.sessionStorage.getItem("data-profile-jaskipin-agen")
      );
      if (profile) {
        return profile;
      } else {
        return null;
      }
    },

    labelData() {
      let profile = JSON.parse(
        localStorage.getItem("data-label-jaskipin-agen")
      );
      if (profile) {
        return profile;
      } else {
        return null;
      }
    },
  },
  methods: {
    handleImage(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
        this.form.image = file;
      }
    },

    async submitForm() {
      try {
        const payload = {
          company_name: this.form.title,
          company_description: this.form.website,
          company_address: this.form.description,
          company_logo: this.imageUrl,
        };
        const response = await axios.put(
          `${api_url}/api/v1/users/user/update/${this.userData.id}`,
          payload,
          { headers: this.headers }
        );
        if (response.status) {
          localStorage.setItem(
            "data-label-jaskipin-agen",
            JSON.stringify(response?.data?.data[0])
          );
          this.successNotification = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style>
.blur-bg {
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px); /* For Safari */
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
